import { DocumentFillIcon } from '@/shared/assets';
import { Typography } from '@/shared/ui';

import { IStatement } from '../../model/schemas';

interface StatementItemProps {
  statement: IStatement;
}

export const RegularStatementItem = ({ statement }: StatementItemProps) => {
  return (
    <div className="flex items-center gap-x-4 py-2">
      <div className="flex size-10 items-center justify-center rounded-full bg-surface-03">
        <DocumentFillIcon />
      </div>

      <div className="flex flex-col gap-y-1">
        <Typography variant="16-r">{statement.name}</Typography>
        <Typography
          variant="14-r"
          color="text-base-100"
          className="tracking-[0.3px]"
        >
          {statement.description}
        </Typography>
      </div>
    </div>
  );
};
